// stores/loadingContext.tsx
import { createContext, useReducer, ReactNode } from 'react'

export interface LoadingOptions {
  text?: string
  countdown?: number
  onCountdownEnd?: () => void
  closable?: boolean
  onCancle?: () => void
  animationData?: any // Lottie 动画数据
}

interface LoadingState {
  visible: boolean
  options?: LoadingOptions
}

const initialState: LoadingState = {
  visible: false,
  options: undefined
}

type Action = { type: 'SHOW_LOADING'; payload?: LoadingOptions } | { type: 'HIDE_LOADING' }

const reducer = (state: LoadingState, action: Action): LoadingState => {
  switch (action.type) {
    case 'SHOW_LOADING':
      return {
        visible: true,
        options: action.payload
      }
    case 'HIDE_LOADING':
      return {
        visible: false,
        options: undefined
      }
    default:
      return state
  }
}

interface LoadingContextValue extends LoadingState {
  show: (options?: LoadingOptions) => void
  hide: () => void
}

export const LoadingContext = createContext<LoadingContextValue>({
  visible: false,
  options: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  show: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  hide: () => {}
})

// export const useGobalLoading = () => useContext(LoadingContext)

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const show = (options?: LoadingOptions) => {
    dispatch({ type: 'SHOW_LOADING', payload: options })
  }

  const hide = () => {
    dispatch({ type: 'HIDE_LOADING' })
  }

  return <LoadingContext.Provider value={{ ...state, show, hide }}>{children}</LoadingContext.Provider>
}
